import React, { useState } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { TextField, CustomSelect, StandardChip } from '../../v2/MUI_custom_component';
import { deliveryType } from '../../utils/settings';

export const deliveryTypeDropDown = [
  { label: 'UP', value: deliveryType.UP },
  { label: 'MIDDLE', value: deliveryType.MIDDLE },
  { label: 'DOWN', value: deliveryType.DOWN },
];

const LogisticDetails = ({
  selectedDeliveryType = '',
  onDeliveryTypeChange = () => {},
  receiverName = '',
  onReceiverNameChange = () => {},
  receiverMobile = '',
  onReceiverMobileChange = () => {},
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        ...sx
      }}
    >
    <Typography variant='h2'> Logistic Details </Typography>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant='labelM' sx={{ color: '#666666'}}>
                Delivery type*
            </Typography>
            <Box sx={{ display: 'flex', gap: 1}}>
                {deliveryTypeDropDown.map((type) => (
                    <StandardChip
                        key={type.value}
                        label={type.label}
                        onClick={() => onDeliveryTypeChange(type.value)}
                        selected={selectedDeliveryType === type.value}
                    />
                ))}
            </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <TextField
                fullWidth
                label="Receiver's Name"
                placeholder="Enter name"
                variant="standard"
                value={receiverName}
                onChange={(e) => onReceiverNameChange(e.target.value)}
                onKeyPress={(e) => {
                    const key = e.key;
                    if (!/[a-zA-Z\s]/.test(key) && key !== 'Backspace' && key !== 'Delete' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
                        e.preventDefault();
                    }
                }}
            />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <TextField
                fullWidth
                label="Receiver's Phone"
                placeholder="Enter Phone"
                variant="standard"
                value={receiverMobile}
                onChange={(e) => onReceiverMobileChange(e.target.value)}
                inputProps={{
                    maxLength: 10,
                    pattern: '[0-9]*',
                }}
                onKeyPress={(e) => {
                const key = e.key;
                    if (isNaN(key) && key !== 'Backspace' && key !== 'Delete' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
                        e.preventDefault();
                    }
                }}
            />
        </Box>
    </Box>
    </Box>
  );
};

export default LogisticDetails;